<template>
  <app-collapse accordion type="margin">
    <app-collapse-item title="معلومات  ">
      <div class="row">
        <div class="col-sm-3">الوضع الحالي</div>
        <div class="col-sm-4">
          <b-badge variant="light-info" v-if="approveal"> موافقة</b-badge>
          <b-badge variant="light-danger" v-else> في انتظار الموافقة </b-badge>
        </div>
      </div>
      <hr />
      <b-row v-if="approveal">
        <div class="col-sm-3">اسم المشرف</div>
        <div class="col-sm-4">
          <b-badge variant="light-info">
            {{ approveal.master_key_status.user.full_name }}</b-badge
          >
        </div>
      </b-row>
      <hr />

      <b-row>
        <div class="col-sm-3">عنوان الخطة</div>
        <div class="col-sm-4">
          <b-badge variant="light-danger"> </b-badge>
        </div>
      </b-row>
      <hr />

      <b-row>
        <div class="col-sm-3">يجب مراعاة التعليمات التالية</div>
        <div class="col-sm-9">
          <app-collapse accordion type="margin">
            <app-collapse-item title="تعليمات الفصل الأول  ">
              <b-row>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات المقدمة
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات خلفية البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات مشكلة البحث</b-button
                >
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات أسئلة/فروض البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  تعليمات أهداف البحث</b-button
                >
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات مصطلحات البحث</b-button
                >
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات أهمية البحث</b-button
                >
                <b-button variant="outline-primary" class="mb-1 col-4">
                  تعليمات هيكل البحث
                </b-button>
              </b-row>
            </app-collapse-item>
            <app-collapse-item title="	تعليمات الفصل الثاني ">
              <b-row>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات أدبيات البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات الإطار النظري
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  تعليمات الدراسات السابقة
                </b-button>
              </b-row>
            </app-collapse-item>
            <app-collapse-item title="	تعليمات الفصل الثالث  ">
              <b-row>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  تعليمات منهجية البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات تصميم البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  تعليمات إجراءات البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  مجتمع البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  حدود البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  عينة البحث
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  طريقة اختيار العينة
                </b-button>
              </b-row>
            </app-collapse-item>
            <app-collapse-item title="	تعليمات الفصل الرابع  ">
              <b-row>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات تحليل البيانات
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  المعلومات
                </b-button>
              </b-row>
            </app-collapse-item>
            <app-collapse-item title=" تعليمات الفصل الخامس ">
              <b-row>
                <b-button variant="outline-primary" class="mb-1 col-4"
                  >تعليمات الخاتمة
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  تعليمات مناقشة النتائج
                </b-button>
                <b-button variant="outline-primary" class="mb-1 col-4">
                  تعليمات التوصيات
                </b-button>
              </b-row>
            </app-collapse-item>
            <app-collapse-item
              title="	الملاحق/  والنماذج الإرشادية للنسخة النهائية للبحث "
            >
              <b-row>
                <b-button variant="outline-primary" class="mb-1">
                  الملاحق/ والنماذج الإرشادية للنسخة النهائية للبحث
                </b-button>
              </b-row>
            </app-collapse-item>
          </app-collapse>
        </div>
      </b-row>
    </app-collapse-item>

    <app-collapse-item title="رفع ملف هيكلة الخطة ">
      <b-row v-if="newItem.id">
        <b-col lg="12">
          <b-button block variant="outline-primary">
            {{ $t("activities.press_to_download") + " " + " ملف هيكلة الخطة " }}
          </b-button>
        </b-col>
      </b-row>
      <hr />
      <upload
        datakey="upload_research_plan"
        :files="files"
        :master="masterId"
      />
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, min_value, max_value } from "@validations";
import MastersDataController from "@/Controllers/MastersDataController";
import Auth from "@/Apis/Auth";
import Comment from "@/views/Page/Activities/components/Comment.vue";
import Upload from "./upload.vue";
import MastersController from "@/Controllers/MastersController";
import Swal from 'sweetalert2'

export default {
  props: {
    master: Number,
     
  },
  components: {
    AppCollapse,
    AppCollapseItem,
    ValidationObserver,
    ValidationProvider,
    required,
    min_value,
    max_value,
    Comment,
    Upload,
  },
  data() {
    return {
      newItem: {},
      suggested_title: {},
      ret: null,
      masterId: Auth.MASTER.id,
      approveal: false,
      files:[]
    };
  },
  async created() {

    const res = await new MastersDataController().GetAll({
      filter:
        "user_id|" +
        +Auth.USER.id +
        "&&master_id|" +
        this.masterId +
        "&&key|upload_research_plan",
      with: ["masterKeyStatus.user"],
    });
    res.forEach((element) => {
      if (element.master_key_status.value == 1) this.approveal = element;
    });
    this.files=res;
    console.log(res);
  },
  methods: {
    async upload() {
      const isValid = await this.$refs.dataForm.validate();
      if (his.newItem.OldeResearchPlan) {
        return { valid: false };
      }
      this.newItem.key = "upload_research_plan";
      this.newItem.master_id = 1;

      // this.ret = await new MastersDataController().From(
      //   this.newItem,
      //   "FormData",
      //   true
      // );
      // if (this.ret) {
      //   this.newItem = this.ret;
      // }
    },
    async returnData() {
      if (!this.approveal) {
        Swal.fire({
        // position: 'top-start',
        icon: 'error',
        title: 'في انتظار الموافقة ',
        text: 'في انتظار الموافقة ',
        showConfirmButton: false,
        timer: 3000,
      })
        return { valid: false };
        
      }
      return { valid: true, data: this.newItem };
    },
  },
};
</script>

<style>
</style>